import FullCalendar from "@fullcalendar/react"
import { MutableRefObject } from "react"
import { TodayWrapper } from "./styles"
import { useTranslation } from "react-i18next"
import { useSetRecoilState } from "recoil"
import { NewCalenderPageCount } from "@store/index"

interface IProps {
	calendarRef: MutableRefObject<FullCalendar | null>
}
export default function GoToday({ calendarRef }: IProps) {
	const  setPageCount = useSetRecoilState(NewCalenderPageCount)

	const { t } = useTranslation()
	const goToday = () => {
		const calendarApi = calendarRef.current?.getApi()
		if (calendarApi) {
			const today = new Date()
			calendarApi.gotoDate(today) // Navigate to current day
			setPageCount(1)
		}
	}
	return (
		<TodayWrapper>
			<button onClick={goToday}>{t("COMMON.TODAY")}</button>
		</TodayWrapper>
	)
}
